import LocationNotesWrapper from "@/pages/locaties/notes/LocationNotesWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/locaties/$locationId/notities/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "locations"),
})

function RouteComponent() {
  const { locationId } = useParams({
    from: "/beheer/locaties/$locationId/notities/",
  })

  return <LocationNotesWrapper locationId={Number(locationId)} />
}
